const defaultLanguageName = 'Russian'

export { defaultLanguageName }
